<script setup lang="ts"></script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="m11 19.654l-1.156-1.042q-2.28-2.087-3.799-3.593q-1.518-1.506-2.413-2.679q-.895-1.173-1.264-2.146Q2 9.221 2 8.225q0-1.908 1.296-3.201Q4.592 3.731 6.5 3.731q1.32 0 2.475.675T11 6.369q.87-1.288 2.025-1.963T15.5 3.73q1.737 0 2.948 1.08q1.212 1.08 1.48 2.689H18.9q-.238-1.23-1.19-2t-2.21-.77q-1.217 0-2.21.688q-.992.688-1.888 2.082h-.804q-.91-1.413-1.907-2.091Q7.694 4.73 6.5 4.73q-1.463 0-2.482.997Q3 6.725 3 8.225q0 .844.35 1.713q.35.87 1.25 2.001t2.45 2.658Q8.6 16.123 11 18.3q.765-.69 1.506-1.363q.74-.674 1.323-1.231l.11.11l.247.247l.247.247l.11.11q-.59.557-1.314 1.208q-.725.65-1.471 1.341zm6.73-3.154v-3h-3v-1h3v-3h1v3h3v1h-3v3z"
        ></path>
    </svg>
</template>
